import CaterIndustry from "../../Sections/CaterIndustry";
import FirstTime from "../../Sections/FirstTime";
import HowItWorks from "../../Sections/HowItWorks";
import ServiceCard from "../../Sections/ServiceCard";
import { Link } from "react-router-dom";
import BottomNav from "../../Layout/BottomNav";
import HomeBannerSlider from "../../Sections/HomeBannerSlider";
import Navbar from "../../Layout/Header";
import { useEffect } from "react";
import WeCanDO from "../../Sections/WeCanDo";
import { Helmet } from "react-helmet";
import ConvertedPrice from "../ConvertedPrice";

const CommercialPage = (props: any) => {
  // useEffect(() => {
  //   props?.setUserDash(true);
  //   return () => props?.setUserDash(false);
  // }, [props]);

  return (
    <>
      {/* <Navbar static={true} /> */}

      <Helmet>
        <title>
          Transform Offices - Commercial Virtual Staging by Stagobox
        </title>
        <meta
          name="description"
          content="Commercial virtual staging & renovation from $22! Transform offices,  Business spaces and more with photorealistic makeovers. Attract buyers/tenants faster."
        />
      </Helmet>
      <BottomNav />

      {/* <WeCanDO /> */}

      <div className="blur-background-box commercial-main">
        <div className="hp-container">
          <div className="page-title pt-5 pb-5 mb-5" data-aos="fade-up">
            <h1>Our Services </h1>
            <p>
              Help your buyers visualize their business setup in a comfy and
              efficient environment by virtually transforming the vacant
              property.
            </p>
          </div>

          <ServiceCard
            imageFront={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Commercial_Virtual_Staging_After_1_Web_1749828526.webp`}
            imageBack={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Commercial_Virtual_Staging_Before_1_Web_1749828526.webp`}
            description="Furnish your empty spaces with our commercial virtual staging service. Realistic, stunning images enable buyers to visualize the full potential of any property, whether it’s an office or any part of your business space."
            title="Commercial Virtual Staging"
            isPlaceOrder={false}
            key={1}
            pageUrl="/services/commercial/virtual-staging"
            exploreBtn={true}
            listItems={[
              <span>
                <b>Guaranteed Best Prices</b> at{" "}
                <b>{<ConvertedPrice price={22} />}</b>
              </span>,
              <span>
                <b>Lightning Fast Turnaround</b> in <b>24-48 hours</b>
              </span>,
              <span>
                <b>Rapid Delivery</b> in <b>just 24 hours</b>
              </span>,
              <b>Free Unlimited Revisions</b>,
              <b>Risk-Free Guarantee**: 100% money-back</b>,
            ]}
          />

          <div className="mt-5 mb-5">
            <ServiceCard
              imageFront={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Commercial_Renovation_After_1_Web_1749828056.webp`}
              imageBack={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Commercial_Renovation_Before_1_Web_1749828057.webp`}
              description="Revitalize your empty commercial spaces with high-quality, lifelike images. Highlight possibilities through stunning visuals, creating a compelling narrative. By showcasing your property's unique features, we ensure your listings stand out and lead to faster sales."
              title="Commercial Renovation"
              isPlaceOrder={false}
              key={1}
              pageUrl="/services/commercial/commercial-renovation"
              exploreBtn={true}
              listItems={[
                <span>
                  <b>
                    Guaranteed Best Prices starting from{" "}
                    {<ConvertedPrice price={5} />}
                  </b>
                </span>,
                <span>
                  <b>Lightning Fast Turnaround</b> in <b>24-48 hours</b>
                </span>,
                <span>
                  <b>Rapid Delivery</b> in <b>just 24 hours</b>
                </span>,
                <b>Free Unlimited Revisions</b>,
                <b>Risk-Free Guarantee**: 100% money-back</b>,
              ]}
            />
          </div>

          <div className="page-title pt-5 pb-5" data-aos="fade-up">
            <h1>
              <span className="underLine">Other Services</span>
            </h1>
          </div>

          <ServiceCard
            imageFront={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Image_Enhancement_After_3_Web_1749847955.webp`}
            imageBack={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Image_Enhancement_Before_3_Web_1749847956.webp`}
            description="We'll enhance the overall quality of your photos, making them sharper, more vibrant, and visually appealing."
            title="Image Enhancement"
            isPlaceOrder={true}
            classes={["mb-5"]}
            key={1}
            pageUrl="/services/image-enhancement-form"
            price={<ConvertedPrice price={1.5} />}
            perPhoto={false}
            listItems={[
              <span>
                <b>Guaranteed Best Price </b>at{" "}
                <b>{<ConvertedPrice price={1.5} />}</b>
              </span>,
              <span>
                <b>Lightning Fast Turnaround</b> in <b>24-48 hours</b>
              </span>,
              <span>
                <b>Rapid Delivery</b> in <b>just 24 hours</b>
              </span>,
              <b>Free Unlimited Revisions</b>,
              <b>Risk-Free Guarantee**: 100% money-back</b>,
            ]}
          />

          <ServiceCard
            imageFront={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Day_to_Dusk_After_3_Web_1749829341.webp`}
            imageBack={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Day_to_Dusk_Before_3_Web_1749829341.webp`}
            description="Transforms daytime photos into captivating, twilight-inspired photos, enhancing their visual appeal."
            title="Day to Dusk"
            classes={["mb-5"]}
            isPlaceOrder={true}
            key={1}
            pageUrl="/services/object-removal-form"
            price={<ConvertedPrice price={5} />}
            perPhoto={false}
            listItems={[
              <span>
                <b>Guaranteed Best Price </b>at{" "}
                <b>{<ConvertedPrice price={5} />}</b>
              </span>,
              <span>
                <b>Lightning Fast Turnaround</b> in <b>24-48 hours</b>
              </span>,
              <span>
                <b>Rapid Delivery</b> in <b>just 24 hours</b>
              </span>,
              <b>Free Unlimited Revisions</b>,
              <b>Risk-Free Guarantee**: 100% money-back</b>,
            ]}
          />

          <ServiceCard
            imageFront={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Object_Removal_After_1_Web_1749849991.webp`}
            imageBack={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Object_Removal_Before_1_Web_1749849991.webp`}
            description="Object removal service in real estate photography seamlessly erases unwanted elements, enhancing property images for 
a pristine presentation."
            title="Object Removal"
            isPlaceOrder={true}
            key={1}
            pageUrl="/services/commercial/object-removal"
            price={<ConvertedPrice price={8} />}
            perPhoto={false}
            classes={["mb-5"]}
            listItems={[
              <span>
                <b>Guaranteed Best Price </b>at{" "}
                <b>{<ConvertedPrice price={8} />}</b>
              </span>,
              <span>
                <b>Lightning Fast Turnaround</b> in <b>24-48 hours</b>
              </span>,
              <span>
                <b>Rapid Delivery</b> in <b>just 24 hours</b>
              </span>,
              <b>Free Unlimited Revisions</b>,
              <b>Risk-Free Guarantee**: 100% money-back</b>,
            ]}
          />

          <ServiceCard
            imageFront={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Occupied_to_Vacant_After_3_Web_1749851204.webp`}
            imageBack={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Occupied_to_Vacant_Before_3_Web_1749851204.webp`}
            description="Converting an occupied space into a vacant one can enhance the property's cleanliness and often leads to increased demand."
            title="Occupied To Vacant"
            isPlaceOrder={true}
            key={1}
            pageUrl="/services/occupied-vacant-form"
            price={<ConvertedPrice price={15} />}
            perPhoto={false}
            classes={["mb-4"]}
            listItems={[
              <span>
                <b>Guaranteed Best Price </b>at{" "}
                <b>{<ConvertedPrice price={15} />}</b>
              </span>,
              <span>
                <b>Lightning Fast Turnaround</b> in <b>24-48 hours</b>
              </span>,
              <span>
                <b>Rapid Delivery</b> in <b>just 24 hours</b>
              </span>,
              <b>Free Unlimited Revisions</b>,
              <b>Risk-Free Guarantee**: 100% money-back</b>,
            ]}
          />
        </div>

        {/* ========== How it works ========== */}
        <HowItWorks redirectionLink={"/services/commercial/virtual-staging"} />

        <div className="hp-container">
          {/* First time */}
          <div data-aos="fade-up">
            <FirstTime />
          </div>

          {/* Industry we are catering */}
          <div data-aos="fade-up">
            <CaterIndustry />
          </div>
        </div>
      </div>
    </>
  );
};

export default CommercialPage;
